import React from "react";
import { IBranchAdmin } from "../types/branch.interface";
import { FaTrash, FaUser } from "react-icons/fa";
import XSButton from "components/button/XSButton";

interface IAdminAvatarProps extends IBranchAdmin {
  handleUpdate?: (id: number) => void;
  handleMove?: (id: number) => void;
  handleDelete?: (id: number) => void;
}

const AdminAvatar: React.FC<IAdminAvatarProps> = (props) => {
  const { id, name, email, handleUpdate, handleMove, handleDelete } = props;

  return (
    <div className="flex w-fit flex-col items-center justify-center">
      <div className="flex h-[87px] w-[87px] items-center justify-center rounded-full border-[4px] border-white bg-brand-50 bg-opacity-30 dark:!border-navy-700">
        <FaUser className="text-2xl text-brand-500" />
      </div>

      {/* Name and position */}
      <div className="mt-1 flex flex-col items-center">
        <p className="text-base font-normal text-gray-700">{name}</p>
        <p className="text-xs font-normal text-brand-500">{email}</p>
        <div className="mt-3 flex items-center gap-5">
          <XSButton
            children={
              <span className="text-xs font-semibold text-brand-500">Edit</span>
            }
            variant="text"
            onClick={() => {
              handleUpdate(id);
            }}
          />
          <XSButton
            children={
              <span className="rounded-2xl bg-brand-500 px-1 text-xs font-medium text-white">
                Pindah
              </span>
            }
            variant="default"
            onClick={() => {
              handleMove(id);
            }}
          />
          <XSButton
            children={<FaTrash className="text-xs text-red-500" />}
            variant="default"
            onClick={() => handleDelete(id)}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminAvatar;
